import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ComponentsModule } from '@fi-app/components/components.module';
import { UtilitiesModule } from '@fi-app/utilities/utilities.module';
import { BusinessAreaViewComponent } from './business-area-view/business-area-view.component';
import { BusinessAreaService } from './business-area.service';
import { BusinessAreaEditComponent } from './business-area-edit/business-area-edit.component';
import { BusinessAreaListComponent } from './business-area-list/business-area-list.component';
import { BusinessAreaListContainerComponent } from './business-area-list-container/business-area-list-container.component';
import { BusinessAreaViewContainerComponent } from './business-area-view-container/business-area-view-container.component';
import { UIRouterModule } from '@uirouter/angular';
import { FiBusinessAreaStates } from '@fi-app/business-area/business-area-states';
import { MatTabsModule } from '@angular/material/tabs';
import { FiPageHeaderButtonGroupModule } from '@fi-shared/fi-page-header-button-group/fi-page-header-button-group.module';
import { FiPageHeaderModule } from '@fi-app/components/fi-page-header/fi-page-header.module';
import { MatCardModule } from '@angular/material/card';
import { FiItemsListModule } from '@fi-shared/fi-items-list/fi-items-list.module';
import { FiLocalSearch2Module } from '@fi-shared/fi-local-search2/fi-local-search2.module';
import { FiWrapperTableModule } from '@fi-shared/fi-wrapper-table/fi-wrapper-table.module';
import { BusinessUnitModule } from '@fi-app/business-unit/business-unit.module';
import { FiBusinessAreaListHelperService } from './business-area-list/fi-business-area-list-helper.service';
@NgModule({
    imports: [
        CommonModule,
        UtilitiesModule,
        FormsModule,
        ComponentsModule,
        MatTabsModule,
        UIRouterModule.forChild(FiBusinessAreaStates),
        FiPageHeaderButtonGroupModule,
        FiPageHeaderModule,
        MatCardModule,
        FiItemsListModule,
        FiLocalSearch2Module,
        FiWrapperTableModule,
        BusinessUnitModule,
    ],
    declarations: [
        BusinessAreaViewComponent,
        BusinessAreaEditComponent,
        BusinessAreaListComponent,
        BusinessAreaListContainerComponent,
        BusinessAreaViewContainerComponent,
    ],
    providers: [BusinessAreaService, FiBusinessAreaListHelperService],
})
export class BusinessAreaModule {}
